import { render } from "./Search-overlay.vue?vue&type=template&id=ab50c56c&scoped=true"
import script from "./Search-overlay.vue?vue&type=script&lang=js"
export * from "./Search-overlay.vue?vue&type=script&lang=js"

import "./Search-overlay.vue?vue&type=style&index=0&id=ab50c56c&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab50c56c"]])

export default __exports__